import React from "react";
import { QATerritories } from "utils/constants";

export function QALocationColumn({ value }){
	const label = QATerritories.find(v => v.value === value)?.label;
	return <div>{label}</div>;
}

const QALocationCell = {
	key: "qaLocation",
	name: "Territory",
	resizable: true,
	sortable: true,
	formatter: QALocationColumn,
};

export default QALocationCell;
